export default __webpack_public_path__ + "static/media/ic_settings_16.e5edd079.svg";